module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAABHNCSVQICAgIfAhkiAAAAUpJREFUOE/F1M9RwkAUx/HvCzfjgRLWCoQKwAqECrQD04D8CQVYinQAVGDsYK1AnIF4yj5n44TBDAkhF/eYZD/5vfc2kX1sEuCWmqWwuZ7Y4S42WxzD65n1ew5L9rHROsDfKxD/rCpblLtj6GIkR0tQK6QMtUaOocuQuZmV+xcErBshKFaVcXkqBdgMqZ//vBJR+BLhUZVIYFDpKLXIBkfU6dB1yur/EN/McGpv0thECi+tkgAf4cSa74UZti4HZa6C7TjWmRCJ8HQyTVVj/WRCh0kDEpTPcGr7u5np+SZ7yDkihPscrZyOT6EsCeiFjmUqDALlPYOuvyaSf8mvJ5HibITPdrlfmBHKAzA6lKEkSJ5uiGBOI45+HjnDZsKbyG/82vWnHMVeKX2/IRVWCL1z+0/3REkUTKMExRvqjn2jFEfTOfujrgWF8Q9mGe3RLUWsWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/MojT2/T2Klub/Icon-awesome-file-pdf.png
// module id = +7cs
// module chunks = 3